export default __webpack_public_path__ + "static/media/icons8-search.32dca9de.svg";